import type { RequestUser } from 'shared-types';

const shouldShowUserNameForm = (user: RequestUser) => {
  return (
    user &&
    user.id !== 1 &&
    user.roles.includes('user') &&
    !user.passwordForceChange &&
    (!user.firstName || !user.lastName)
  );
};

export default shouldShowUserNameForm;
